
import { categories } from "@/lib/mockData";
import FilterChip from "../property/FilterChip";
import { Badge } from "@/components/ui/badge";
import { X } from "lucide-react";

interface CategoryFilterProps {
  selectedCategories: string[];
  onToggleCategory: (category: string) => void;
  onClearCategories: () => void;
}

const CategoryFilter = ({
  selectedCategories,
  onToggleCategory,
  onClearCategories,
}: CategoryFilterProps) => {
  // Filter out the "all" category
  const filteredCategories = categories.filter((cat) => cat.id !== "all");

  // Get display name for a category
  const getCategoryDisplayName = (categoryId: string) => {
    const category = filteredCategories.find(cat => cat.id === categoryId);
    return category?.name || categoryId;
  };

  return (
    <div className="p-4 border-b border-gray-200">
      <div className="flex justify-between items-center mb-3">
        <h3 className="font-medium text-sm text-gray-500">LISTING TYPE</h3>
        {selectedCategories.length > 0 && (
          <button
            onClick={onClearCategories}
            className="text-xs text-propertylk-blue hover:underline"
          >
            Clear
          </button>
        )}
      </div>
      
      {/* Display selected categories as badges */}
      {selectedCategories.length > 0 && (
        <div className="flex flex-wrap gap-1 mb-2">
          {selectedCategories.map((category) => (
            <Badge 
              key={category}
              variant="secondary" 
              className="pl-2 pr-1 py-0.5 text-sm bg-blue-100 text-blue-800 border border-blue-200"
            >
              {getCategoryDisplayName(category)}
              <button
                onClick={() => onToggleCategory(category)}
                className="ml-1 p-0.5 rounded-full hover:bg-blue-300"
                aria-label={`Remove ${getCategoryDisplayName(category)} filter`}
              >
                <X className="h-3 w-3" />
              </button>
            </Badge>
          ))}
        </div>
      )}
      
      <div className="flex flex-wrap gap-2">
        {filteredCategories.map((category) => (
          <FilterChip
            key={category.id}
            label={category.name}
            isSelected={selectedCategories.includes(category.id)}
            onClick={() => onToggleCategory(category.id)}
          />
        ))}
      </div>
    </div>
  );
};

export default CategoryFilter;
